<template>
  <div >
      <navbar />
       <ReviewComment/>
       <!-- <footer2/> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

import navbar from '../components/navbar'
import ReviewComment from '../components/ReviewComment'

export default {
  name: 'HelloWorld',
  data () {
    return {

    }
  },
    computed: {
         ...mapState(["profilemenumargin"]),
    },
  components:{
      navbar,
      ReviewComment
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.marginmenu{
  margin-right:400px;
  transition: all 0.5s;
}
.margin0{
  margin-right: 0;
  transition: all 0.5s
}
/* @media screen and (min-width: 1088px){
.container {
    max-width: calc(98vw - 400px);
    width: calc(98vw - 400px);
}
}
@media screen and (min-width: 1280px){
.container {
    max-width: calc(98vw - 400px);
    width: calc(98vw - 400px);
}
}

@media only screen and (max-width: 1087px) {
  .container{
    padding:5px
  }
} 

@media only screen and (max-width: 769px) {
  .container{
    padding:5px
  }
} 
@media only screen and (max-width: 760px) {
  .marginmenu{
    margin-right: 0px !important
  }
} */
</style>



// WEBPACK FOOTER //
// src/views/ReviewComment.vue